import { render, staticRenderFns } from "./UrnCompartmentPlaqueEngraving.vue?vue&type=template&id=55ed0462&"
import script from "./UrnCompartmentPlaqueEngraving.vue?vue&type=script&lang=js&"
export * from "./UrnCompartmentPlaqueEngraving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports